module.exports = __webpack_public_path__ + "static/media/0058_Small.1cf17bbb.jpg";